import { useEffect, useState } from 'react';

export default function AllVouchersPage() {
  const [vouchers, setVouchers] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://dashboard.cohere.ph/api/get_all_vouchers.php', {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          setError(data.error);
          setVouchers([]);
        } else {
          setVouchers(data);
        }
      })
      .catch(err => {
        console.error(err);
        setError('Failed to load vouchers');
      });
  }, []);

  if (error) return <p className="text-red-500 p-4">{error}</p>;
  if (!vouchers.length) return <p className="p-4">Loading vouchers...</p>;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">All Vouchers (Admin)</h1>
      <div className="grid gap-4">
        {vouchers.map(v => (
          <div key={v.code} className="border p-4 rounded shadow">
            <p><strong>Code:</strong> {v.code}</p>
            <p><strong>Email:</strong> {v.email}</p>
            <p><strong>Issued:</strong> {v.issue_date}</p>
            <p><strong>Expires:</strong> {v.expires_at}</p>
            <p><strong>Status:</strong> {v.used ? '✅ Used' : '🟢 Available'}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
